import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { ProgramSetupAxios } from "../../../API";
import CdxModal from "../../../shared/modal/CdxModal";

const ProgramSchedule = (props) => {
    const [show, setShow] = React.useState(false);
    const [timeTable, setTimeTable] = React.useState([]);
    const [taskList, setTaskList] = React.useState([]);
    const [missions, setMissions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState(0);

    useEffect(() => {
        ProgramSetupAxios.get(`/OfferingMission/getmissionsbyoffering/${props.offeringId}`)
            .then(function (response) {
                let missions = response.data.filter(mission => mission.sameAs === 0);
                console.log(missions);
                setMissions(missions);

                const missionId = response.data[0].id;
                setActiveTab(missionId);
            })
            .catch(function (error) {
                console.log(error);
            });

    }, [props.offeringId, props.offeringUserId]);

    const getMissionData = (missionId) => {
        setLoading(true);
        ProgramSetupAxios.get("OfferingMission/getmissionbyid/" + missionId + "/0")
            .then(function (missionReponse) {
                setTaskList(missionReponse.data.tasks.filter(x => x.activityTypeId != 6));
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });

    };

    useEffect(() => {
        if (activeTab) {
            getMissionData(activeTab);
        }
    }, [activeTab]);

    useEffect(() => {
        let stageNames = [];

        if (taskList && taskList.length > 0) {
            let list = taskList.sort((a, b) => a.sequence - b.sequence);
            list.forEach(task => {
                if (!stageNames.includes(task.stageName)) {
                    stageNames.push(task.stageName);
                }
            });

            let timeData = stageNames.map(stageName => {
                let stageData = {
                    stageName: stageName,
                    activities: []
                };
                list.forEach(task => {
                    if (task.stageName === stageName) {
                        stageData.activities.push({
                            activityName: task.activityName,
                            activityStartDate: task.activityStartDate,
                            activityEndDate: task.activityEndDate
                        });

                    }
                });
                return stageData;
            });

            setTimeTable(timeData);
        }

    }, [show, taskList]);

    const handleClose = () => setShow(false);

    const getFormatedDate = (item) => {
        const date = new Date(item + "Z");
        // let year = date.getFullYear();
        let month = date.getMonth();
        let dt = date.getDate();

        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        if (item)
            return `${monthNames[month]} ${dt}`;
        else
            return "-";
    };

    return <>
        <button className="cdx-btn program-info-schedule" onClick={() => { setShow(true); }} >Schedule</button>

        <CdxModal
            show={show}
            onHide={handleClose}
            onClose={handleClose}
            noBorder={true}
            size="xl"
            fullWidth={true}
            scrollable={true}
        >
            <CdxModal.Header onClose={handleClose} className="cdx-modal-schedule">
                <div className="rect-header title">
                    Program Schedule
                </div>
            </CdxModal.Header>
            <CdxModal.Body className="cdx-modal-schedule-body pt-0">
                {missions.length > 1 &&
                    <div className="tab-wrapper pt-3">
                        <div className="tabs">
                            {missions.map(mission => {
                                let isActive = activeTab === mission.id ? " active" : "";
                                return <>
                                    <div className={"tab-wrap " + isActive} onClick={() => setActiveTab(mission.id)}>
                                        <div className="tab-item" key={'tab-' + mission.id}>
                                            <div className="tab-title">{mission.missionName}</div>
                                        </div>
                                    </div>
                                </>;
                            })}
                        </div>
                    </div>
                }
                <div className="row scdl-header">
                    <div className="col-md-2 ps-3">
                        Stage Name
                    </div>
                    <div className="col-md row m-0 p-0">

                        <div className="col-md ps-5">
                            Activity Name
                        </div>
                        <div className="col-md-2 text-center">
                            Start Date
                        </div>
                        <div className="col-md-2 text-center">
                            End Date
                        </div>
                    </div>
                </div>

                <div className="scdl-body">
                    {loading ? <div className="loader">
                        <Spinner
                            animation="border"
                            role="status"
                            variant="primary"
                        />
                        <span>Loading...</span>
                    </div>
                        : <>{timeTable.length > 0 ? timeTable.map((stage, index) => {
                            return <>
                                <div className="row" key={"stage-" + index}>
                                    <div className="col-md-2 ps-3 py-2">
                                        {stage.stageName}
                                    </div>
                                    <div className="col-md ">
                                        {stage.activities.map((activity, index) => {
                                            return <div className="row m-0 activity-name" key={"activity-" + index}>
                                                <div className="col-md ps-5 p-2">
                                                    {activity.activityName}
                                                </div>
                                                <div className="col-md-2 text-center p-2">
                                                    {getFormatedDate(activity.activityStartDate)}
                                                </div>
                                                <div className="col-md-2 text-center p-2">
                                                    {getFormatedDate(activity.activityEndDate)}
                                                </div>
                                            </div>;
                                        })}
                                    </div>
                                </div>
                                <div className="b-bottom"></div>
                            </>;
                        })
                            :
                            <div className="row ">
                                <div className="col-md-12 text-center blank-activities">
                                    Activities not found
                                </div>
                            </div>}
                        </>}
                </div>
            </CdxModal.Body>
        </CdxModal>
    </>;
};

export default ProgramSchedule;